export class ViolationHistoryImageResultDto {
  name: string;
  url: string;
}
